import HTTPClient from '../..'
import { useMutation } from '@tanstack/react-query'

export const deleteNoteApi = async (id: string) => {
  const { data } = await HTTPClient.delete(`/notes/${id}`)
  return data
}

export const useDeleteNote = () => useMutation(['delete-note'], deleteNoteApi)
